import servise from '@/router/axios'

// 分页查询推广计划列表
export const getCampaignPage = (params) => {
  return servise({
    url: '/ocpx/campaign/page',
    method: 'get',
    params
  })
}

// 根据ID查询推广计划详情
export const getCampaignById = (id) => {
  return servise({
    url: `/ocpx/campaign/${id}`,
    method: 'get'
  })
}

// 根据计划编码查询
export const getCampaignByCode = (campaignCode) => {
  return servise({
    url: `/ocpx/campaign/code/${campaignCode}`,
    method: 'get'
  })
}

// 根据广告主ID查询计划列表
export const getCampaignListByAdvertiserId = (advertiserId) => {
  return servise({
    url: `/ocpx/campaign/advertiser/${advertiserId}`,
    method: 'get'
  })
}

// 新增推广计划
export const addCampaign = (data) => {
  return servise({
    url: '/ocpx/campaign',
    method: 'post',
    data
  })
}

// 更新推广计划
export const updateCampaign = (data) => {
  return servise({
    url: '/ocpx/campaign',
    method: 'put',
    data
  })
}

// 删除推广计划
export const deleteCampaign = (id) => {
  return servise({
    url: `/ocpx/campaign/${id}`,
    method: 'delete'
  })
}

// 更新推广计划状态
export const updateCampaignStatus = (id, status) => {
  return servise({
    url: `/ocpx/campaign/${id}/status/${status}`,
    method: 'put'
  })
}
